import React from 'react';
import { Button } from 'react-bootstrap';
import { navigate, StaticQuery, graphql } from 'gatsby';
import { RichText } from 'prismic-reactjs';
import { gastbyLinkResolver as linkResolver } from '../utils';
import htmlSerializer from '../htmlSerializer';
import { isLoggedIn } from '../services/auth.api';

interface Props {
  page_id: string;
  pagename: string;
}

const JoinFurFamily = (props: Props) => {
  if (isLoggedIn()) {
    return null;
  }
  const onGetStarted = () => {
    navigate('/getstarted/');
  };
  return (
    <div className="join-fam-wrapper">
      <div className="container-fluid">
        <div className="fam-hdr text-center">
          <StaticQuery
            query={`${footerQuery}`}
            render={data => {
              const allFooters = data.allPrismicFooter.edges;
              const footerData = allFooters.filter(
                (item: { node: { uid: string } }) =>
                  item.node?.uid === props.page_id,
              );
              const {
                main_text = {},
                content = {},
              } = footerData[0]?.node?.data || {};
              return (
                <div>
                  <p className="txt-bold">Are you ready to see your dog at their healthiest?</p>
                  <h2
                    dangerouslySetInnerHTML={{
                      __html: RichText.asText(main_text.raw).replace(
                        '20% OFF',
                        '<span style="color: #fb6a43;";">20% OFF</span>'
                      ),
                    }}
                  />
                  <p
                    dangerouslySetInnerHTML={{
                      __html: RichText.asText(content.raw).replace(
                        'FREE',
                        '<strong>FREE</strong>'
                      ),
                    }}
                  />
                </div>
              );
            }}
          />
        </div>

        <div className="btn-wrapper text-center">
          <Button className="btn-def mgn-top-30" onClick={onGetStarted}>
            {props.pagename === 'aboutPage'
              ? 'Create my furbaby meal plan'
              : 'Build your feeding plan'}
          </Button>
        </div>
      </div>
    </div>
  );
};

const footerQuery = graphql`
  {
    allPrismicFooter {
      edges {
        node {
          id
          uid
          data {
            main_text {
              text
              html
              raw
            }
            content {
              text
              html
              raw
            }
          }
        }
      }
    }
  }
`;

export default JoinFurFamily;
